export const PORTION_TYPE_BOWL = 'bowl'
export const PORTION_TYPE_BATCH = 'batch'

export default [
  PORTION_TYPE_BOWL,
  PORTION_TYPE_BATCH
]
